// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__2-r3S","mensagem":"OptionSelect_mensagem__39jxr","focado":"OptionSelect_focado__3G8Xa"};